<template>
  <div class="app-container">
    <div class="header-search__form">
      <el-form :inline="true" :model="searchForm" size="small">
        <el-form-item label="类别">
          <el-radio-group v-model="searchForm.searchType" fill="#175e77">
            <el-radio-button label="日" />
            <el-radio-button label="月" />
            <el-radio-button label="年" />
          </el-radio-group>
        </el-form-item>
        <el-form-item label="日期">
          <el-date-picker
            v-show="searchForm.searchType === '日'"
            v-model="searchForm.searchDate"
            :clearable="false"
            type="date"
            placeholder="选择日期"
          />
          <el-date-picker
            v-show="searchForm.searchType === '月'"
            v-model="searchForm.searchDate"
            :clearable="false"
            type="month"
            placeholder="选择日期"
          />
          <el-date-picker
            v-show="searchForm.searchType === '年'"
            v-model="searchForm.searchDate"
            :clearable="false"
            type="year"
            placeholder="选择日期"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-video-play"
            :loading="loadingConfig.loading"
            @click="queryPreview"
          >预览</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="body-content__container">
      <div
        v-loading="loadingConfig.loading"
        class="left-data__container"
        :element-loading-text="loadingConfig.loadingTxt"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <!-- 电费汇总 -->
        <el-table :data="[statisticResult.feeSum]" :style="{ width: '100%' }" size="mini" height="144px">
          <el-table-column
            :label="`${statisticResult.statistics.length > 0
              ? statisticResult.statistics[0].orgname
              : ''
            }${statisticResult.statistics.length > 0
              ? statisticResult.statistics[0].formatdate
              : ''}电费汇总`"
            class-name="
            table-header__title"
            align="center"
          >
            <el-table-column
              prop="formatdate"
              label="日期"
              class-name="table-header__date"
              align="center"
              width="120px"
            />
            <el-table-column prop="light" label="照明消纳电费[元]" class-name="table-header__light" align="center">
              <el-table-column
                prop="lightingenergy.sharp"
                label="尖"
                align="center"
                class-name="table-header__light__cell"
              />
              <el-table-column
                prop="lightingenergy.peak"
                label="峰"
                align="center"
                class-name="table-header__light__cell"
              />
              <el-table-column
                prop="lightingenergy.flat"
                label="平"
                align="center"
                class-name="table-header__light__cell"
              />
              <el-table-column
                prop="lightingenergy.valley"
                label="谷"
                align="center"
                class-name="table-header__light__cell"
              />
              <el-table-column
                prop="lightingenergy.dvalley"
                label="深谷"
                align="center"
                class-name="table-header__light__cell"
              />
              <el-table-column
                prop="lightingenergy.total"
                label="总"
                align="center"
                class-name="table-header__light__cell"
              />
            </el-table-column>
            <el-table-column prop="load" label="动力消纳电费[元]" class-name="table-header__load" align="center">
              <el-table-column
                prop="reloadenergy.sharp"
                label="尖"
                align="center"
                class-name="table-header__load__cell"
              />
              <el-table-column
                prop="reloadenergy.peak"
                label="峰"
                align="center"
                class-name="table-header__load__cell"
              />
              <el-table-column
                prop="reloadenergy.flat"
                label="平"
                align="center"
                class-name="table-header__load__cell"
              />
              <el-table-column
                prop="reloadenergy.valley"
                label="谷"
                align="center"
                class-name="table-header__load__cell"
              />
              <el-table-column
                prop="reloadenergy.dvalley"
                label="深谷"
                align="center"
                class-name="table-header__load__cell"
              />
              <el-table-column
                prop="reloadenergy.total"
                label="总"
                align="center"
                class-name="table-header__load__cell"
              />
            </el-table-column>
            <el-table-column prop="grid" label="光伏上网电费[元]" class-name="table-header__grid" align="center">
              <el-table-column prop="gridenergy.sharp" label="尖" align="center" class-name="table-header__grid__cell" />
              <el-table-column prop="gridenergy.peak" label="峰" align="center" class-name="table-header__grid__cell" />
              <el-table-column prop="gridenergy.flat" label="平" align="center" class-name="table-header__grid__cell" />
              <el-table-column
                prop="gridenergy.valley"
                label="谷"
                align="center"
                class-name="table-header__grid__cell"
              />
              <el-table-column
                prop="gridenergy.dvalley"
                label="深谷"
                align="center"
                class-name="table-header__grid__cell"
              />
              <el-table-column prop="gridenergy.total" label="总" align="center" class-name="table-header__grid__cell" />
            </el-table-column>
          </el-table-column>
        </el-table>
        <!-- 电量汇总 -->
        <el-table :data="[statisticResult.statistics]" :style="{ width: '100%' }" size="mini" height="144px">
          <el-table-column
            :label="`${statisticResult.statistics.length > 0
              ? statisticResult.statistics[0].orgname
              : ''
            }${statisticResult.statistics.length > 0
              ? statisticResult.statistics[0].formatdate
              : ''
            }电量汇总`"
            class-name="table-header__title"
            align="center"
          >
            <el-table-column
              prop="formatdate"
              label="日期"
              class-name="table-header__date"
              align="center"
              width="120px"
            />
            <el-table-column label="照明消纳电量[kwh]" class-name="table-header__light" align="center">
              <el-table-column
                v-for="(item, index) in shareKeys"
                :key="index"
                :prop="`lightingenergy.${item.prop}`"
                :label="item.label"
                align="center"
                class-name="table-header__light__cell"
              />
            </el-table-column>
            <el-table-column label="动力消纳电量[kwh]" class-name="table-header__load" align="center">
              <el-table-column
                v-for="(item, index) in shareKeys"
                :key="index"
                :prop="`reloadenergy.${item.prop}`"
                :label="item.label"
                align="center"
                class-name="table-header__load__cell"
              />
            </el-table-column>
            <el-table-column label="光伏上网电量[kwh]" class-name="table-header__grid" align="center">
              <el-table-column
                v-for="(item, index) in shareKeys"
                :key="index"
                :prop="`gridenergy.${item.prop}`"
                :label="item.label"
                align="center"
                class-name="table-header__grid__cell"
              />
            </el-table-column>
          </el-table-column>
        </el-table>
        <!-- 电量明细 -->
        <el-table
          :data="statisticResult.detaillist"
          :style="{ width: '100%', backgroundColor: 'transparent' }"
          :header-row-style="tableDetailRowHeaderStyle"
          size="mini"
          height="calc(100% - 288px)"
        >
          <el-table-column label="明细" class-name="table-header__detail" align="center">
            <el-table-column prop="createtime" class-name="table-header__date" align="center" width="120px" />
            <el-table-column
              v-for="(itemShare, shareIndex) in ['sharp', 'peak', 'flat', 'valley', 'dvalley', 'total']"
              :key="`lightingenergy_${shareIndex}`"
              :prop="`lightingenergy.${itemShare}`"
              align="center"
              class-name="table-header__light__cell"
            />
            <el-table-column
              v-for="(itemShare, shareIndex) in ['sharp', 'peak', 'flat', 'valley', 'dvalley', 'total']"
              :key="`reloadenergy_${shareIndex}`"
              :prop="`reloadenergy.${itemShare}`"
              align="center"
              class-name="table-header__load__cell"
            />
            <el-table-column
              v-for="(itemShare, shareIndex) in ['sharp', 'peak', 'flat', 'valley', 'dvalley','total']"
              :key="`gridenergy_${shareIndex}`"
              :prop="`gridenergy.${itemShare}`"
              align="center"
              class-name="table-header__grid__cell"
            />
          </el-table-column>
        </el-table>
      </div>
      <div class="right-data__container">
        <!-- 汇总 -->
        <el-row :gutter="8">
          <el-col :span="8">
            <el-statistic
              group-separator=","
              title="照明消纳电费[元]"
              class="statistic-container"
              :value-style="{ color: 'white' }"
              :precision="2"
              :value="feeCalcResult.light"
            />
          </el-col>
          <el-col :span="8">
            <el-statistic
              group-separator=","
              title="动力消纳电费[元]"
              class="statistic-container"
              :value-style="{ color: 'white' }"
              :precision="2"
              :value="feeCalcResult.load"
            />
          </el-col>
          <el-col :span="8">
            <el-statistic
              group-separator=","
              title="光伏上网电费[元]"
              class="statistic-container"
              :value-style="{ color: 'white' }"
              :precision="2"
              :value="feeCalcResult.grid"
            />
          </el-col>
        </el-row>
        <el-row :gutter="8">
          <el-col :span="8">
            <el-statistic
              group-separator=","
              title="厂区应付电费[元]"
              class="statistic-container"
              :value-style="{ color: 'white' }"
              :precision="2"
              :value="feeCalcResult.factoryNeedPay"
            />
          </el-col>
          <el-col :span="8">
            <el-statistic
              group-separator=","
              title="供电局应付电费[元]"
              class="statistic-container"
              :value-style="{ color: 'white' }"
              :precision="2"
              :value="feeCalcResult.powerSupplyBureauNeedPay"
            />
          </el-col>
        </el-row>

        <!-- 电价 -->
        <el-form
          :model="priceForm"
          label-position="left"
          label-width="180px"
          size="mini"
          class="price-form"
          :style="{ paddingBottom: '0' }"
        >
          <el-form-item label="供电局尖电价[元/kWh]">
            <el-input-number v-model="priceForm.sharp" :precision="4" :step="0.0001" :min="0.0001" />
          </el-form-item>
          <el-form-item label="供电局峰电价[元/kWh]">
            <el-input-number v-model="priceForm.peak" :precision="4" :step="0.0001" :min="0.0001" />
          </el-form-item>
          <el-form-item label="供电局平电价[元/kWh]">
            <el-input-number v-model="priceForm.flat" :precision="4" :step="0.0001" :min="0.0001" />
          </el-form-item>
          <el-form-item label="供电局谷电价[元/kWh]">
            <el-input-number v-model="priceForm.valley" :precision="4" :step="0.0001" :min="0.0001" />
          </el-form-item>
          <el-form-item label="供电局深谷电价[元/kWh]">
            <el-input-number v-model="priceForm.dvalley" :precision="4" :step="0.0001" :min="0.0001" />
          </el-form-item>
          <el-form-item label="供电局上网电价[元/kWh]">
            <el-input-number v-model="priceForm.grid" :precision="4" :step="0.0001" :min="0.0001" />
          </el-form-item>
          <el-form-item label="照明电价[元/kWh]">
            <el-input-number v-model="priceForm.light" :precision="4" :step="0.0001" :min="0.0001" />
          </el-form-item>
        </el-form>

        <!-- 折扣 -->
        <el-form
          :model="emcPriceForm"
          label-position="left"
          label-width="180px"
          size="mini"
          class="price-form emc-price__form"
          :style="{ paddingTop: '0' }"
        >
          <el-form-item label="EMC折扣电价">
            <el-input-number v-model="emcPriceForm.discount" :precision="4" :step="0.0001" :min="0.0001" />
          </el-form-item>
          <el-form-item label="EMC折扣尖电价[元/kWh]">
            <el-input-number v-model="emcPriceForm.sharp" :precision="4" :step="0.0001" :min="0.0001" />
          </el-form-item>
          <el-form-item label="EMC折扣峰电价[元/kWh]">
            <el-input-number v-model="emcPriceForm.peak" :precision="4" :step="0.0001" :min="0.0001" />
          </el-form-item>
          <el-form-item label="EMC折扣平电价[元/kWh]">
            <el-input-number v-model="emcPriceForm.flat" :precision="4" :step="0.0001" :min="0.0001" />
          </el-form-item>
          <el-form-item label="EMC折扣谷电价[元/kWh]">
            <el-input-number v-model="emcPriceForm.valley" :precision="4" :step="0.0001" :min="0.0001" />
          </el-form-item>
          <el-form-item label="EMC折扣深谷电价[元/kWh]">
            <el-input-number v-model="emcPriceForm.dvalley" :precision="4" :step="0.0001" :min="0.0001" />
          </el-form-item>
          <el-form-item label="EMC折扣照明电价[元/kWh]">
            <el-input-number v-model="emcPriceForm.light" :precision="4" :step="0.0001" :min="0.0001" />
          </el-form-item>
          <el-form-item label-width="0">
            <el-button
              type="primary"
              :style="{ width: 'calc(50% - 5px)', margin: '5px 5px 5px 0', float: 'left' }"
              :loading="loadingConfig.loading"
              :disabled="statisticResult.feeSum.length === 0"
              @click="calcuFee().calcuStart()"
            >计算</el-button>

            <el-button
              type="primary"
              :style="{ width: 'calc(50% - 5px)', margin: '5px 0 5px 5px' }"
              :loading="loadingConfig.loading"
              @click="resetPrice"
            >
              重置电价
            </el-button>

            <el-button
              type="primary"
              icon="el-icon-download"
              :style="{ width: '100%', margin: '5px 0 0 0' }"
              :loading="loadingConfig.loading"
              @click="queryExport"
            >导出</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
const {
  LizhuStationFeeSettlementPreview,
  LizhuStationFeeSettlementExport,
} = require("@/api/Stations")
const dayjs = require("dayjs")
export default {
  name: "LizhuSettlement",
  data () {
    return {
      /** 查询表单 */
      searchForm: {
        /** 查询类型 天/月/年 */
        searchType: "日",
        /** 查询日期 yyyy-MM-dd / yyyy-MM / yyyy */
        searchDate: dayjs().format("YYYY-MM-DD"),
        /** 查询类型对应接口的key */
        searchTypeKey: {
          日: "day",
          月: "month",
          年: "year",
        },
      },
      /** 加载状态 */
      loadingConfig: {
        /** 是否加载中 */
        loading: false,
        /** 状态说明 */
        loadingTxt: "",
      },
      /** 价格表单 */
      priceForm: {
        /** 供电局尖电价 */
        sharp: 1,
        /** 供电局峰电价 */
        peak: 1,
        /** 供电局平电价 */
        flat: 1,
        /** 供电局谷电价 */
        valley: 1,
        /** 供电局深度电价 */
        dvalley: 1,
        /** 供电局上网电价 */
        grid: 1,
        /** 照明电价 */
        light: 1,
      },
      /** EMC折扣价格 */
      emcPriceForm: {
        /** 折扣 */
        discount: 1,
        /** EMC折扣尖 */
        sharp: 1,
        /** EMC折扣峰 */
        peak: 1,
        /** EMC折扣平 */
        flat: 1,
        /** EMC折扣谷 */
        valley: 1,
        /** EMC折扣深谷 */
        dvalley: 1,
        /** EMC折扣照明 */
        light: 1,
      },
      /** 电费计算结果 */
      feeCalcResult: {
        /** 照明消纳电费 */
        light: 0,
        /** 动力消纳电费 */
        load: 0,
        /** 光伏上网电费 */
        grid: 0,
        /** 厂区应付电费 */
        factoryNeedPay: 0,
        /** 供电局应付电费 */
        powerSupplyBureauNeedPay: 0
      },
      /** 统计结果 */
      statisticResult: {
        /** 电费汇总 */
        feeSum: [],
        /** 电量汇总 */
        statistics: [],
        /** 电量明细 */
        detaillist: [],
      },
      /** 费率 */
      shareKeys: [
        {
          label: '尖',
          prop: 'sharp'
        },
        {
          label: '峰',
          prop: 'peak'
        },
        {
          label: '平',
          prop: 'flat'
        },
        {
          label: '谷',
          prop: 'valley'
        },
        {
          label: '深谷',
          prop: 'dvalley'
        },
        {
          label: '总',
          prop: 'total'
        }
      ],
    }
  },
  computed: {
    /** 明细数据表格头样式 */
    tableDetailRowHeaderStyle () {
      return ({ row, rowIndex }) => {
        let result = {}
        if (rowIndex === 1) {
          result = { display: "none" }
        }
        return result
      }
    },
  },
  methods: {
    /** 获取预览数据 */
    queryPreview () {
      this.loadingConfig.loadingTxt = "获取预览数据"
      this.loadingConfig.loading = true
      const postParam = {
        searchtype: this.searchForm.searchTypeKey[this.searchForm.searchType],
        searchdate: this.searchForm.searchDate,
        orgid: this.$store.getters.station.id,
      }
      this.statisticResult.statistics = []
      this.statisticResult.detaillist = []
      this.statisticResult.feeSum = []
      this.resetFee()
      LizhuStationFeeSettlementPreview(postParam)
        .then(({ data }) => {
          this.statisticResult.feeSum = JSON.parse(JSON.stringify(data.statistics))
          this.statisticResult.statistics = data.statistics
          this.statisticResult.detaillist = data.detaillist
        })
        .catch(() => { })
        .finally(() => {
          this.loadingConfig.loading = false
          this.loadingConfig.loadingTxt = ""
        })
    },

    /** 获取并导出报表数据 */
    queryExport () {
      this.loadingConfig.loadingTxt = "正在导出报告"
      this.loadingConfig.loading = true
      const postParam = {
        searchtype: this.searchForm.searchTypeKey[this.searchForm.searchType],
        searchdate: this.searchForm.searchDate,
        orgid: this.$store.getters.station.id,
        price: this.priceForm,
        eMCPrice: this.emcPriceForm
      }
      LizhuStationFeeSettlementExport(postParam)
        .then((response) => {
          this.downloadExportFile(response.data)
        })
        .catch(() => { })
        .finally(() => {
          this.loadingConfig.loading = false
          this.loadingConfig.loadingTxt = ""
        })
    },

    /** 导出报表数据 */
    downloadExportFile (fileUrl) {
      const link = document.createElement('a')
      link.href = fileUrl
      link.click()
      link.remove()
    },

    /** 计算电费 */
    calcuFee () {
      return {

        /** 开始计算 */
        calcuStart: () => {
          this.calcuFee().calcuEMCPrice()
          this.calcuFee().calcuLight()
          this.calcuFee().calcuReload()
          this.calcuFee().calcuGrid()
          this.calcuFee().calcuFactoryNeedPay()
          this.calcuFee().calcuPowerSupplyBureauNeedPay()
          this.calcuFee().calcuEnd()
        },

        /** 计算EMC折扣电价 */
        calcuEMCPrice: () => {
          const { sharp, peak, flat, valley, dvalley, light } = this.priceForm
          this.emcPriceForm.sharp = Number((sharp * this.emcPriceForm.discount).toFixed(4))
          this.emcPriceForm.peak = Number((peak * this.emcPriceForm.discount).toFixed(4))
          this.emcPriceForm.flat = Number((flat * this.emcPriceForm.discount).toFixed(4))
          this.emcPriceForm.valley = Number((valley * this.emcPriceForm.discount).toFixed(4))
          this.emcPriceForm.dvalley = Number((dvalley * this.emcPriceForm.discount).toFixed(4))
          this.emcPriceForm.light = Number((light * this.emcPriceForm.discount).toFixed(4))
        },

        /** 计算照明电费 */
        calcuLight: () => {
          const { sharp, peak, flat, valley, dvalley, total } = this.statisticResult.statistics.lightingenergy
          this.statisticResult.feeSum.lightingenergy.sharp = Number((sharp * this.emcPriceForm.light).toFixed(2))
          this.statisticResult.feeSum.lightingenergy.peak = Number((peak * this.emcPriceForm.light).toFixed(2))
          this.statisticResult.feeSum.lightingenergy.flat = Number((flat * this.emcPriceForm.light).toFixed(2))
          this.statisticResult.feeSum.lightingenergy.valley = Number((valley * this.emcPriceForm.light).toFixed(2))
          this.statisticResult.feeSum.lightingenergy.dvalley = Number((dvalley * this.emcPriceForm.light).toFixed(2))
          this.statisticResult.feeSum.lightingenergy.total = Number((total * this.emcPriceForm.light).toFixed(2))
          this.feeCalcResult.light = Number((total * this.emcPriceForm.light).toFixed(2))
        },

        /** 计算负载/动力消纳电费 */
        calcuReload: () => {
          const { sharp, peak, flat, valley, dvalley } = this.statisticResult.statistics.reloadenergy
          this.statisticResult.feeSum.reloadenergy.sharp = Number((sharp * this.emcPriceForm.sharp).toFixed(2))
          this.statisticResult.feeSum.reloadenergy.peak = Number((peak * this.emcPriceForm.peak).toFixed(2))
          this.statisticResult.feeSum.reloadenergy.flat = Number((flat * this.emcPriceForm.flat).toFixed(2))
          this.statisticResult.feeSum.reloadenergy.valley = Number((valley * this.emcPriceForm.valley).toFixed(2))
          this.statisticResult.feeSum.reloadenergy.dvalley = Number((dvalley * this.emcPriceForm.dvalley).toFixed(2))
          const reloadenergyTotal = [
            this.statisticResult.feeSum.reloadenergy.sharp,
            this.statisticResult.feeSum.reloadenergy.peak,
            this.statisticResult.feeSum.reloadenergy.flat,
            this.statisticResult.feeSum.reloadenergy.valley,
            this.statisticResult.feeSum.reloadenergy.dvalley
          ].reduce((p, n) => p + n)
          this.statisticResult.feeSum.reloadenergy.total = Number(reloadenergyTotal.toFixed(2))
          this.feeCalcResult.load = Number(reloadenergyTotal.toFixed(2))
        },

        /** 计算光伏上网电费 */
        calcuGrid: () => {
          const { sharp, peak, flat, valley, dvalley, total } = this.statisticResult.statistics.gridenergy
          this.statisticResult.feeSum.gridenergy.sharp = Number((sharp * this.priceForm.grid).toFixed(2))
          this.statisticResult.feeSum.gridenergy.peak = Number((peak * this.priceForm.grid).toFixed(2))
          this.statisticResult.feeSum.gridenergy.flat = Number((flat * this.priceForm.grid).toFixed(2))
          this.statisticResult.feeSum.gridenergy.valley = Number((valley * this.priceForm.grid).toFixed(2))
          this.statisticResult.feeSum.gridenergy.dvalley = Number((dvalley * this.priceForm.grid).toFixed(2))
          this.statisticResult.feeSum.gridenergy.total = Number((total * this.priceForm.grid).toFixed(2))
          this.feeCalcResult.grid = Number((total * this.priceForm.grid).toFixed(2))
        },

        /** 计算厂区应支付电费[ 照明消纳电费 + 动力消纳电费] */
        calcuFactoryNeedPay: () => {
          this.feeCalcResult.factoryNeedPay = Number((this.feeCalcResult.light + this.feeCalcResult.load).toFixed(2))
        },

        /** 计算供电局应支付电费[光伏上网电费] */
        calcuPowerSupplyBureauNeedPay: () => {
          this.feeCalcResult.powerSupplyBureauNeedPay = this.feeCalcResult.grid
        },

        /** 计算结束 */
        calcuEnd: () => {
          // this.feeCalcResult.feeSum = [feeSum]
        }
      }
    },

    /** 重置电费数据 */
    resetFee () {
      this.feeCalcResult.light = 0
      this.feeCalcResult.load = 0
      this.feeCalcResult.grid = 0
      this.feeCalcResult.factoryNeedPay = 0
      this.feeCalcResult.powerSupplyBureauNeedPay = 0
    },

    /** 重置电价 */
    resetPrice () {
      this.priceForm.sharp = 1
      this.priceForm.peak = 1
      this.priceForm.flat = 1
      this.priceForm.valley = 1
      this.priceForm.dvalley = 1
      this.priceForm.grid = 1
      this.priceForm.light = 1

      this.emcPriceForm.sharp = 1
      this.emcPriceForm.peak = 1
      this.emcPriceForm.flat = 1
      this.emcPriceForm.valley = 1
      this.emcPriceForm.dvalley = 1
      this.emcPriceForm.total = 1
      this.emcPriceForm.light = 1
      if (this.statisticResult.feeSum.length !== 0) {
        this.calcuFee().calcuStart()
      }
    }
  },
}
</script>
<style lang="stylus" scoped>
.app-container {
    background-color: #1c2550;
    height: calc(100vh - 100px);
    padding: 0 10px;
    box-sizing: border-box;
    overflow: auto;
    .header-search__form {
        height: 50px;
        width: 100%;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        padding: 0 20px;
        .el-form-item {
            margin-bottom: 0;
            .el-radio-button {
                background-color: transparent;
                color: white;
                >>>span {
                    background-color: transparent;
                    color: white;
                    border: thin solid #175e77;
                    border-left: none;
                }
            }
            .el-radio-button:nth-of-type(1) {
                >>>span {
                    border-left: thin solid #175e77;
                }
            }

            .el-date-editor {
                margin-top: 0;
                >>>input{
                    background-color: transparent;
                    border: thin solid #175e77;
                    color: white;
                }
            }
            .el-button {
                background-color: rgb(23, 94, 119);
                border: none;
            }
        }
    }
    .body-content__container {
        height: calc(100% - 70px);
        width: fit-content;
        box-sizing: border-box;
        border: thin solid #175e77;
        display: flex;
        .left-data__container {
            height: 100%;
            width: calc(100% - 400px);
            min-width: 1600px;
            box-sizing: border-box;
            overflow: auto;
            border-right: thin solid #175e77;
            .el-table {
                border: none;
            }
            >>>.el-table--border::after, >>>.el-table--group::after, >>>.el-table::before {
                background-color: #175e77;
            }
            >>>.table-header__date {
                background-color: #ed7d31;
                color: white;
                border: thin solid #175e77;
                border-top: none;
                border-left: none;
            }
            >>>.table-header__light {
                background-color: #5b9bd5;
                color: white;
                border-color: #5b9bd5;
            }
            >>>.table-header__light__cell {
                background-color: #2f75bb;
                color: white;
                border: thin solid #175e77;
                border-top: none;
                border-left: none;
            }
            >>>.table-header__load {
                background-color: #333f4f;
                color: white;
                border-color: #333f4f;
            }
            >>>.table-header__load__cell {
                background-color: #44546a;
                color: white;
                border: thin solid #175e77;
                border-top: none;
                border-left: none;
            }
            >>>.table-header__grid {
                background-color: #00b050;
                color: white;
                border-color: #00b050;
            }
            >>>.table-header__grid__cell {
                background-color: #548235;
                color: white;
                border: thin solid #175e77;
                border-top: none;
                border-left: none;
            }
            >>>.table-header__title {
                background-color: #000000;
                color: white;
                border-color: #000000;
            }
            >>>.table-header__detail {
                background-color: #000000;
                color: white;
                border: thin solid #000000;
            }
        }
        .left-data__container::-webkit-scrollbar {
            height: 10px;
            width: 6px;
        }
        .left-data__container::-webkit-scrollbar-thumb {
            border-radius: 10px;
            -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
            background: #535353;
        }
        .right-data__container {
            height: 100%;
            width: 355px;
            min-width: 355px;
            box-sizing: border-box;
            .price-form {
                height: fit-content;
                width: 100%;
                padding: 10px;
                margin-top: 20px;
                box-sizing: border-box;
                >>> .el-form-item {
                  margin-bottom: 5px;
                }
                >>> .el-form-item__label {
                    line-height: 30px;
                    padding: 0px;
                }
                >>> .el-input-number {
                    margin-top: 0px;
                }
                .el-button {
                    background-color: rgb(23, 94, 119);
                    border: none;
                }
            }

            .emc-price__form{
              >>> .el-form-item__label {
                color: red !important;
              }
            }

            .statistic-container {
                margin-top: 20px;
                >>> .title {
                    color: white;
                }
            }
        }
    }
}
</style>
